(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('DayOff', function ($resource) {
            return $resource('api/day-off/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'importYear': {method: 'POST', url: 'api/day-off/import'}
            });
        })
        .service('DayOffDialogService', function ($uibModal) {
            this.open = function (item) {
                return $uibModal.open({
                    templateUrl: 'app/entities/day-off/dialog.html',
                    controller: 'DayOffDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        item: function () {
                            return angular.copy(item || {id: null});
                        }
                    }
                }).result;
            };
        });
})();
